import axios from './axios';

export const fetchCardVariations = async () => {
    const response = await axios.get('/cardVariation');
    return response.data;
};

export const createCardVariation = async (data) => {
    const response = await axios.post('/cardVariation', data);
    return response.data;
};

export const updateCardVariation = async (variationID, data) => {
    const response = await axios.put(`/cardVariation/${variationID}`, data);
    return response.data;
};

export const deleteCardVariation = async (variationID) => {
    const response = await axios.delete(`/cardVariation/${variationID}`);
    return response.data;
};
